import { Injectable } from '@angular/core';
import moment from 'moment-mini';
import { DATE_ONLY_FORMATS } from '../../constants/date-only-formats';
import { DATE_TIME_FORMATS } from '../../constants/date-time-formats';

@Injectable()
export class CalendarService {
  dateOnlyFormatList: string[] = [];
  dateTimeFormatList: string[] = [];

  constructor() {
    this.setFormats();
  }

  private setFormats(): void {
    this.dateOnlyFormatList = DATE_ONLY_FORMATS;
    this.dateTimeFormatList = DATE_TIME_FORMATS;
  }

  getValidDate(dateString: string): Date | null {
    const m = moment(dateString, this.dateOnlyFormatList, true);
    if (m !== null && m.isValid()) {
      return m.toDate();
    } else {
      return null;
    }
  }

  getValidDateTime(dateString: string): Date | null {
    const m = moment(dateString, this.dateTimeFormatList, true);
    if (m !== null && m.isValid()) {
      return m.toDate();
    } else {
      return null;
    }
  }
}
